declare const __webpack_public_path__: string;

export const PUBLIC_PATH = __webpack_public_path__;
